var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { withTheme } from 'styled-components';
import { Header1 } from './typography';
var Section = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  padding: 1.5em 2.5em;\n"], ["\n  background-color: ", ";\n  padding: 1.5em 2.5em;\n"])), function (p) {
  return p.theme.level3;
});

var DashboardSection = function DashboardSection(_a) {
  var children = _a.children,
      theme = _a.theme,
      title = _a.title;
  return React.createElement(Section, {
    className: "dashboard-section container" + (theme.fluid ? '-fluid' : '')
  }, React.createElement(Header1, {
    className: "dashboard-section-header"
  }, title), children);
};

export default withTheme(DashboardSection);
var templateObject_1;